import authService from './auth.service';
import type { ChangelogResponse } from '../types/changelog.types';

const API_URL = '/api/v1/changelog';

class ChangelogService {
  async getChangelog(limit?: number): Promise<ChangelogResponse> {
    const url = limit ? `${API_URL}?limit=${limit}` : API_URL;
    const res = await authService.fetchWithAuth(url);
    if (!res.ok) {
      throw new Error(`Ошибка загрузки changelog: ${res.status}`);
    }
    return res.json();
  }
}

const changelogService = new ChangelogService();
export default changelogService;
